<template>
  <div>
    <div class="container hero">
      <div class="column align-items-center">
        <h1 class="text-center">Thank You</h1>
        <p class="text-center">
          <strong style="font-size:20px;">Thanks for choosing American Credit, Inc.</strong><br />
          Our Business Financing Specialist will contact you shortly.<br />To expedite your approval process, please upload all the supporting documents such as equipment invoices and bank statements in the “File Upload” section at Customer Center.
        </p>
        <router-link 
          to="/personalCenter"
          tag="button" class="cta d-block mx-auto"
        >Go to customer center</router-link>
        <!-- <router-link to="/industries/" tag="button" class="cta d-block mx-auto"
          >View More Industries</router-link
        > -->
        <h2 class="text-center">
          For immediate assistance or help with an application, please contact
          us at:
        </h2>
        <span class="text-center mx-auto d-block"
          >Sales: <a href="tel:8559040188">855-904-0188</a></span
        >
      </div>
    </div>
    <div class="container posts-grid">
      <div class="column">
        <h2 class="text-center">Recent Blog Posts</h2>
        <div class="row cards-row">
          <div
            class="col-12 col-md-6 col-lg-4 mb-4"
            v-for="(post, index) in postsGrid"
            :key="index"
          >
            <div class="card px-0" @click="redirectTo(post.routeName)">
              <img
                v-lazy="getImagePath(post.image)"
                :alt="post.title"
                class="card-img-top"
              />
              <div class="card-body">
                <span class="eyebrows">{{ post.eyebrows }}</span>
                <h3>{{ post.title }}</h3>
                <p>{{ post.text }}</p>
                <div class="row mx-0 w-75 justify-content-between post-details">
                  <span class="text-uppercase">{{ post.author }}</span>
                  <span class="text-uppercase">{{
                    post.date.toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      postsGrid: [
        {
          title: "4 Important things to know before financing equipment.",
          eyebrows: "Equipment finance tips",
          text: "Smart equipment financing decisions are empowered with access to the right information and knowing key lender data points. Make sure you have access...",
          author: "Corey Rockafeler",
          date: new Date(2022, 0, 19),
          image: "industries/equipment-term-loan.webp",
          routeName: "4-important-things-to-know-before-financing-equipment",
        },
        {
          title: "How to qualify for equipment financing.",
          eyebrows: "Equipment Financing",
          text: "Equipment financing is a cost-effective and efficient way for small businesses to acquire needed assets to increase profitability. Investments in...",
          author: "Corey Rockafeler",
          date: new Date(2021, 10, 29),
          image: "industries/equipment-financing.png",
          routeName: "how-to-qualify-for-equipment-financing",
        },
        {
          title: "What is an equipment sale-leaseback?",
          eyebrows: "Small Business Tips",
          text: "Many small businesses in need of capital are utilizing equipment sale-leasebacks to unlock the equity on free and clear equipment.",
          author: "Corey Rockafeler",
          date: new Date(2021, 10, 12),
          image: "industries/equipment-sale-leaseback.webp",
          routeName: "what-is-an-equipment-sale-leaseback",
        },
      ],
    };
  },
  methods: {
    getImagePath(imagePath) {
      return `/static/assets/imgs/${imagePath}`;
    },
    redirectTo(postName) {
      window.location = "https://blog.amcredit.com/" + postName;
    },
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title =
      "Thanks for contacting American Credit, Inc. | American Credit";
    meta.content =
      "American Credit offers business financing to a variety of business industries. Choose your industry & learn how we help business owners just like you everyday!";
  },
};
</script>

<style lang="scss" scoped>
.container.hero {
  max-width: 800px;
  padding-top: 60px;
  padding-bottom: 80px;

  span {
    font-size: 18px;
    font-weight: 600;

    a {
      font-size: inherit;
      font-weight: inherit;
    }
  }
}

h1 {
  font-family: "Biotif", "Helvetica", sans-serif;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 30px !important;
  @media (min-width: 992px) {
    font-size: 54px !important;
    margin-bottom: 20px;
  }
}

p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.cta {
  margin-bottom: 80px;
}

h2 {
  font-size: 30px !important;
  font-weight: 700;
  margin: 0;
  margin-bottom: 20px;
  text-align: center;
  font-family: "Biotif", "Helvetica", sans-serif;

  @media (min-width: 768px) {
    font-size: 36px !important;
  }
}

.cards-row {
  margin-bottom: 80px;
}

.card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 11px 30px rgba(100, 146, 253, 0.2);
  height: 100%;

  &:hover,
  &:focus {
    cursor: pointer;
  }
}

.card-img-top {
  height: 250px;
  object-fit: cover;
  object-position: center;
}

.card-body {
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}

.eyebrows {
  color: #5456ff;
  font-weight: 900;
  font-family: "Biotif", "Helvetica", sans-serif;
  margin-bottom: 20px;
  display: block;
}

h3 {
  font-weight: 900;
  font-family: "Biotif", "Helvetica", sans-serif;
  font-size: 24px;
}

p {
  font-weight: 600;
  margin-bottom: 48px;
}

.post-details {
  color: #c6c6c6;
  font-weight: 600;
  font-size: 12px;
  margin-top: auto;
}

.posts-grid {
  h2 {
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// thankYou.vue?b2981374